<template>
  <div>
    <QCChartReport></QCChartReport>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const QCChartReport = defineAsyncComponent(() =>
  import("@/components/QCCharts/QCChartReport")
);
export default {
  components: {
    QCChartReport,
  },
};
</script>
